<template>
  <section
    v-if="data.is_paused"
    class="locker-item pause"
    :style="{'width': `${size}px`, 'height': `${size}px`}"
  >
    <article class="locker-item__header">
      <span class="locker-num">
        {{ data.name }}
      </span>
      <more-action-dropdown
        icon-type="more-light"
        :payload-data="data"
        :dropdown-items="lockerDropdownHasRestartItem"
        @command="handleClickDropdownItem"
      />
    </article>
  </section>
  <section
    v-else-if="!targetHistory"
    class="locker-item empty"
    :style="{'width': `${size}px`, 'height': `${size}px`}"
  >	
    <article class="locker-item__header">
      <span class="locker-num">
        {{ data.name }}
      </span>
      <more-action-dropdown
        icon-type="more-light"
        :payload-data="data"
        :dropdown-items="lockerDropdownHasStopItem"
        @command="handleClickDropdownItem"
      />
    </article>
  </section>
  <section
    v-else
    :class="`locker-item ${lockerStatus === LOCKER_STATUS.OCCUPIED ? 'occupied' : 'scheduled'}`"
    :style="{'width': `${size}px`, 'height': `${size}px`}"
  >
    <article class="locker-item__header">
      <span class="locker-num">
        {{ data.name }}
      </span>
      <more-action-dropdown
        :icon-type="lockerStatus === LOCKER_STATUS.OCCUPIED ? &quot;more-white&quot; : &quot;more-light&quot;"
        :payload-data="data"
        :dropdown-items="lockerDropdownHasStopItem"
        @command="handleClickDropdownItem"
      />
    </article>
    <article class="locker-item__contents">
      <div
        class="locker-title"
        @click="handleClickUser"
      >
        {{ lockerStatus === LOCKER_STATUS.OCCUPIED ? this.targetHistory.name : `(예정)${this.targetHistory.name}` }}
      </div>
      <div
        class="locker-duration"
        @click="handleClickUser"
      >
        {{ duration }}
      </div>
    </article>
  </section>
</template>

<script>
import dateFns from 'date-fns';
import { LOCKER_STATUS } from '@/constants';
import MoreActionDropdown from '@/components/MoreActionDropdown';

const lockerDropdownHasStopItem = [
  {
    action: 'list',
    label: '전체 내역',
  },
  {
    action: 'stop',
    label: '락커 이용 중지',
  },
];

const lockerDropdownHasRestartItem = [
  {
    action: 'list',
    label: '전체 내역',
  },
  {
    action: 'restart',
    label: '락커 중지 해제',
  },
];

export default {
  name: 'LockerItem',
  props: [
    'data', 'isPlus', 'size',
  ],
  components:{
    MoreActionDropdown,
  },
  data(){
    return {
      lockerStatus : LOCKER_STATUS.EMPTY,
      targetHistory: undefined,
      LOCKER_STATUS: LOCKER_STATUS,
      lockerDropdownHasStopItem,
      lockerDropdownHasRestartItem,
    };
  },
  watch:{
    data:{
      immediate: true,
      handler:function(data){
        const sameDateData = this.sameDateData(data);
        if(sameDateData){
          this.lockerStatus = LOCKER_STATUS.OCCUPIED;
          this.targetHistory = sameDateData;
          return; 
        }
        const afterDateData = this.afterDateData(data);
        if(afterDateData){
          this.lockerStatus = LOCKER_STATUS.SCHEDULED;
          this.targetHistory = afterDateData;
          return;
        }
        this.lockerStatus = LOCKER_STATUS.EMPTY;
      },
    },
    size:{
      immediate:true,
      handler(size){

      },
    },
  },
  computed: {
    duration() {
      if (!this.targetHistory) {
        return '';
      }

      return `${dateFns.format(
        this.targetHistory.start,
        'YY.MM.DD',
      )}-${dateFns.format(this.targetHistory.end, 'YY.MM.DD')}`;
    },
  },
  methods: {
    handleClickDropdownItem({ action, data }) {
      this.$emit('click', {
        action: action,
        locker: {
          ...data,
          lockerStatus : this.lockerStatus,
        },
        targetHistory: this.targetHistory,
      });
    },
    handleClickUser() {
      return this.$router.push(`/member/${this.targetHistory.enrollment_id}/`).catch(()=>{});
    },
    sameDateData(data) {
      const curDate = new Date();
      return data.histories.find(history=> {
        const startDatetime = dateFns.startOfDay(history.start);
        const endDatetime = dateFns.endOfDay(history.end);
        return dateFns.isWithinRange(curDate, startDatetime, endDatetime);
      });
    },
    afterDateData(data) {
      return data.histories.find(history=> {
        const startDatetime = dateFns.startOfDay(history.start);
        return dateFns.isFuture(startDatetime);
      });
    },
  },
};
</script>

<style lang="scss">
.locker-item {
	position: relative;
	display: flex !important;
	flex-direction: column;
	justify-content: space-between;
	border-radius: 10px;
	box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.19);
	border: solid 1.5px #d3d3d3;
	background: #ffffff;
	box-sizing: border-box;
	width: 100px;
	height: 100px;
	padding: 8px;
	margin: 9px 9px 0 0;
	cursor: pointer;
	overflow: hidden;


	.locker-item__header{
		display: flex;
		justify-content: space-between;
	}
	
	.el-dropdown{
		position: absolute;
		top: 0;
		right: 0;
	}

	.locker-title{
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin-bottom: 3px;
	}

	.locker-num {
		font-size: 12px;
		color: #b9b9b9;
		letter-spacing: -0.69px;
	}

	&:hover {
		box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
	}

	&.plus {
		border: 1.5px dashed #b9b9b9;
		border-radius: 10px;
		text-align: center;
		
		.ic-plus-inactive{
			margin: auto;
		}

		.plus-words {
			font-size: 13px;
			color: #9b9b9b;
			letter-spacing: -0.74px;
		}
	}

	&.occupied {
		background-color: #9b9b9b;

		.locker-num {
			color: white;
		}

		.locker-title {
  			font-size: 14px;
  			font-weight: 500;
  			font-stretch: normal;
  			font-style: normal;
  			line-height: normal;
			color: #ffffff;
			letter-spacing: -0.8px;
		}

		.locker-duration {
  			font-size: 10px;
  			font-weight: normal;
  			font-stretch: normal;
  			font-style: normal;
  			line-height: normal;
			color: #ffffff;
			letter-spacing: -0.6px;
		}
	}

	&.scheduled {
		background-color: #f2f2f2;
			
		.locker-num {
			color: #9b9b9b;
		}

		.locker-title {
  			font-size: 14px;
  			font-weight: 500;
  			font-stretch: normal;
  			font-style: normal;
  			line-height: normal;
			color: #9b9b9b;
			letter-spacing: -0.8px;
		}

		.locker-duration {
  			font-size: 10px;
  			font-weight: normal;
  			font-stretch: normal;
  			font-style: normal;
  			line-height: normal;
			color: #9b9b9b;
			letter-spacing: -0.6px;
		}
	}

	&.pause {
		border: 1.5px solid #f2f2f2;
		border-radius: 10px;

		&:before {
			content: "";
			display: block;
			border: 1px solid #f2f2f2;
			transform: rotate(-45deg);
			transform-origin: left;
			position: absolute;
			bottom: 0;
			left: 0;
			width: 300px;
		}

		&:after {
			content: "";
			display: block;
			border: 1px solid #f2f2f2;
			transform: rotate(45deg);
			transform-origin: left;
			position: absolute;
			top: 0;
			left: 0;
			width: 300px;
		}
	}

	@media screen and (max-width: 768px) {
		width: 80px;
		height: 80px;
		margin: 5px 5px 0 0;
		padding: 4px;

		.el-dropdown{
			width: 20px;
			height: 20px;
			position: absolute;
			top: 0;
			right: 4px;
		}

		.locker-num {
			font-size: 12px;
			color: #b9b9b9;
			letter-spacing: -0.69px;
		}
		
		&.occupied{
			.locker-title {
  				font-size: 13px;
			}
		}

		&.scheduled {
			.locker-title {
  				font-size: 13px;
			}
		}

		&.pause {
			border: 1.5px solid #f2f2f2;
			border-radius: 10px;
		}
	}
}
</style>
